export const CANONICAL_ORIGIN = "https://theorieaanbieders.nl";

const CANONICAL_HOSTS = [
  "https://theorieaanbieders.nl",
  "http://theorieaanbieders.nl",
  "http://theorieaanbieders.nl",
  CANONICAL_ORIGIN,
] as const;

export const normalizeCanonicalUrl = (url: string): string => {
  if (!url) return CANONICAL_ORIGIN;

  const normalized = url.startsWith("/") ? `${CANONICAL_ORIGIN}${url}` : url;

  return CANONICAL_HOSTS.reduce(
    (currentUrl, host) => currentUrl.replace(host, CANONICAL_ORIGIN),
    normalized,
  );
};

export const normalizeExternalUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("//")) return `https:${url}`;
  return `https://${url}`;
};
